/*!
 * name ZJX 主页面盒子作为承载页面使用
 * Copyright 2018-2019
 */
<template>
  <div class="app_content">
    <headers></headers>
    <!-- 一级路由主盒子 -->
    <div class="app_routing_content">
      <router-view/>
    </div>
    <footers></footers>
  </div>
</template>
<script>
import headers from "@/components/header"; //引入头部
import footers from "@/components/footer"; //引入尾部


export default {
  data() {
    return {};
  },
  methods: {},
  components: {
    headers,
    footers
  },
  created() {

  }
};
</script>
<style lang="scss" scoped>
.app_content {
  background: #fdf8f2;
  width: 100%;
  height: 100%;
}
.app_routing_content {
  width: 80%;
  position: relative;
  background: #fff;
  margin: 0 auto;
}
</style>
